import type { PostData } from '@/data/mockData'

type BusinessLite = {
  name?: unknown
  zone?: unknown
  emoji?: unknown
  verified?: unknown
  cover_colors?: unknown
}

/** Convierte una fila de `posts` de Supabase (+ su negocio) al formato que espera PostCard. */
export function mapPostRow(
  row: Record<string, unknown>,
  business: BusinessLite | undefined
): PostData {
  return {
    id: row.id as string,
    biz: row.business_id as string,
    type: row.type as string,
    title: row.title as string,
    img: (business?.cover_colors as [string, string]) ?? ['#0F5C5C', '#17706f'],
    desc: (row.description as string) ?? '',
    cat: (row.category as string) ?? 'comer',
    date: row.scheduled_date as string | undefined,
    start: row.start_time as string | undefined,
    price: row.price_info as string | undefined,
    age: row.min_age as string | undefined,
    dress: row.dress_code as string | undefined,
    cond: row.conditions as string | undefined,
    mood: row.mood as string | undefined,
    occ: row.occupancy as string | undefined,
    interested: (row.interested_count as number) ?? 0,
    bizName: business?.name as string | undefined,
    bizZone: business?.zone as string | undefined,
    bizEmoji: business?.emoji as string | undefined,
    bizVerified: business?.verified as boolean | undefined,
  }
}
